require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/node_modules/core-js/library/modules/es7.symbol.observable.js
// module id = 461
// module chunks = 0